module.exports = __webpack_public_path__ + "img/search.7cee79a0.png";